import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import i from './FactImageThumbnail.css'; // eslint-disable-line css-modules/no-unused-class

import Fact from './Fact';

function HoC(props) {
  return (
    <Fact
      id="information"
      className="clearfix"
      title="Livsmedelsverkets information"
      {...props}
    >
      <p className={i.root}>
        <a
          rel="noopener noreferrer"
          href="https://www.livsmedelsverket.se/globalassets/produktion-handel-kontroll/vagledningar-kontrollhandbocker/information-om-anvandandet-av-livsmedelsverkets-kostrad.pdf"
          target="_blank"
        >
          <img
            className={i.image}
            alt="PDF"
            src="https://s3-eu-west-1.amazonaws.com/kostradsguiden/livsmedelsverket.jpg"
          />
        </a>
      </p>
      <p>
        {'Läs '}
        <a
          rel="noopener noreferrer"
          href="https://www.livsmedelsverket.se/globalassets/produktion-handel-kontroll/vagledningar-kontrollhandbocker/information-om-anvandandet-av-livsmedelsverkets-kostrad.pdf"
          target="_blank"
        >
          {`
            Livsmedelsverkets information om användandet av
            Livsmedelsverkets kostråd i märkning och marknadsföring av
            enskilda produkter
          `}
        </a>
        {' när du ska kommunicera kostråd.'}
      </p>
      <p>
        {`
          Här står t ex att ett kostråd inte får ge intryck av att
          Livsmedelsverket har godkänt eller rekommenderat en viss produkt,
          eller på annat sätt kopplas ihop med den enskilda produkten.
        `}
      </p>
    </Fact>
  );
}

export default withStyles(i)(HoC);



// WEBPACK FOOTER //
// ./src/components/Fact/FactLivsmedelverketsInformation.js